export const mapConfig = {
  center: { lat: 46.52863469527167, lng: 2.43896484375 }, // France
  zoom: 12,
};
